import { render, staticRenderFns } from "./StvrtMap.vue?vue&type=template&id=b46132a2"
import script from "./StvrtMap.vue?vue&type=script&lang=js"
export * from "./StvrtMap.vue?vue&type=script&lang=js"
import style0 from "./StvrtMap.vue?vue&type=style&index=0&id=b46132a2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports